<mat-expansion-panel class="jobs-panel" *ngIf="runs.length">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon>pending_actions</mat-icon>
      Background jobs ({{ runs.length }})
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="run-row" *ngFor="let item of runs">
    <div class="run-main">
      <strong>{{ item.label }}</strong>
      <span class="meta" *ngIf="item.roleSlug">
        <a [routerLink]="['/admin/career-roles', item.roleSlug]">{{ item.roleSlug }}</a>
      </span>
      <mat-chip [style.background-color]="statusColor(item.run?.status)" style="color:#fff">
        {{ item.run?.status ?? 'queued' }}
      </mat-chip>
      <span class="meta" *ngIf="item.run?.operationType">{{ item.run?.operationType }}</span>
      <p class="history" *ngIf="latestMessage(item)">{{ latestMessage(item) }}</p>
      <mat-progress-bar
        *ngIf="item.run && item.run.status !== 'completed' && item.run.status !== 'failed'"
        mode="determinate"
        [value]="item.run.progressPercentage"></mat-progress-bar>
    </div>
    <button mat-icon-button type="button" (click)="dismiss(item.runId)" title="Dismiss">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <a mat-button routerLink="/admin/background-jobs">Job recovery</a>
</mat-expansion-panel>
